/**
 * 设施类型管理路由配置
 */
const deviceTypeRoutes = {
  path: 'deviceType',
  name: 'deviceType',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'deviceTypeList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '设施类型管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default deviceTypeRoutes;
